import React, { Component } from 'react'
import moment from 'moment'

import { connect } from 'react-redux'

import {
	toggleTimer,
	openModal
} from 'state/actions'

import { 
	secondsToTimeString,
	formatStandardDateTime,
	doSort,
	textTimeString,
	formatByTimeZone
} from 'utils'

import ProfilePicture from 'components/profile/profile-picture'
import AlertBanner from 'components/alerts/alert-banner'
import Icon from 'components/icon/icon'

import Button from 'components/button/button'

import { MainContext } from 'context'

class SingleTaskTiming extends Component {
	updateInterval = null

	sessionData = null

	UNSAFE_componentWillMount = _ => {
		this.updateInterval = setInterval(_ => {
			this.forceUpdate()
		},1000)
	}

	componentWillUnmount = _ => {
		clearInterval(this.updateInterval)
	}
	
	generateSessionData = _ => {
		const {
			allSessions,
			allUsers,
			taskObject
		} = this.props

		const thisUser = this.context.user

        let sessionGroups = []
		let totalSeconds = 0
		
		let isCurrentUserStillRunning = false

        taskObject.sessions && taskObject.sessions.forEach(sessionId => {
			const session = allSessions[sessionId]
			if(!session){				
				return 
			}
			const user = allUsers[session.user_id] || {
				id: -1,
				first_name: '(Deleted',
				last_name: ' user)'
			}

			const isStillRunning = !session.stopped_at

			if(session.deleted_at){
				return
			}

			if(isStillRunning && user.id === thisUser.id){
				isCurrentUserStillRunning = true
			}
			
			const stoppedAtMoment = session.stopped_at ? formatByTimeZone(session.stopped_at, null, true) : moment()

            const sessionDayUtc = formatByTimeZone(session.created_at, null, true).startOf('day').valueOf()
            const lengthInSeconds = stoppedAtMoment.diff(formatByTimeZone(session.created_at, null, true),'seconds')

            totalSeconds += lengthInSeconds

            const groupIndexIfExisting = sessionGroups.findIndex(group => {
                return group.date == sessionDayUtc
            })

            if(groupIndexIfExisting >= 0){
				const userIndexIfExisting = sessionGroups[groupIndexIfExisting].userSessions.findIndex(userSession => {
					return userSession.user.id == user.id
				})

				if(userIndexIfExisting >= 0){
					sessionGroups[groupIndexIfExisting].userSessions[userIndexIfExisting].seconds += lengthInSeconds

					if(formatByTimeZone(sessionGroups[groupIndexIfExisting].userSessions[userIndexIfExisting].lastActive, null, true).isBefore(formatByTimeZone(session.updated_at, null, true))){
						sessionGroups[groupIndexIfExisting].userSessions[userIndexIfExisting].lastActive = session.updated_at

						if(isStillRunning){
							sessionGroups[groupIndexIfExisting].userSessions[userIndexIfExisting].isStillRunning = true
						}
					}
				}else{
					sessionGroups[groupIndexIfExisting].userSessions.push({
						user,
						seconds: lengthInSeconds,
						lastActive: session.updated_at,
						isStillRunning
					})
				}
            }else{
                // create a new one
                sessionGroups.push({
                    date: sessionDayUtc,
					userSessions: [{
						user,
						seconds: lengthInSeconds,
						lastActive: session.updated_at,
						isStillRunning
					}]
                })
            }
		})

		sessionGroups.forEach(sessionGroup => {
			sessionGroup.userSessions = doSort(sessionGroup.userSessions, 'date', 'lastActive', true)
		})

		sessionGroups.sort((a,b) => {
			return b.date - a.date
		})

        return {
            sessionGroups,
			totalSeconds,
			isCurrentUserStillRunning
        }
	}

	toggleTimer = _ => {
		const {
			toggleTimer,
			taskObject
		} = this.props

		toggleTimer(taskObject)
	}

	openAddManualTime = _ => {
		const { openModal, taskObject } = this.props

		openModal('add-time', 'session', {
			taskId: taskObject.id
		})
	}
	
	render() {
		const {
			currentTab,
			taskObject
		} = this.props

		const {
            sessionGroups,
			totalSeconds,
			isCurrentUserStillRunning
		} = this.generateSessionData()

		return (
			<div>
				<div className="single-task-timing">
					{ taskObject.estimated_minutes ?
					<div className="time-figure-container">
						<label>
							Estimated:
						</label>
						<span className="time-figure">
							{ textTimeString(taskObject.estimated_minutes, 'minutes', true) }
						</span>
					</div>
					: null }
					{ totalSeconds ?
						<div className="time-figure-container">
							<label>
								Total tracked:
							</label>
							<span className="time-figure">
								{ totalSeconds ? textTimeString(totalSeconds, 'seconds', true) : null }
							</span>
						</div>
					: null }
					<Button
						size='big'
						level={isCurrentUserStillRunning ? 'high' : 'low'}
						icon="fe-clock"
						callback={this.toggleTimer}
						label={isCurrentUserStillRunning ? 'Stop timer' : 'Start timer'}
						forcePressed={isCurrentUserStillRunning}
					/>
					<Button
						size='big'
						level='x-low'
						icon="fe-plus"
						callback={this.openAddManualTime}
						label='Add manual time'
					/>
					{ !totalSeconds ? 
						<AlertBanner 
							low={true} 
							title={'No times tracked'} 
							body={"When your team has tracked any time on this task, it'll show here."} 
						/>
					:
						<div className="session-groups-container">
							<ul className="session-groups">
							{ sessionGroups.map((group, index) => {
								return (
									<li key={index} className="session-group">
										<label>
											{ formatStandardDateTime(group, 'date', true) }
										</label>
										{ group.userSessions.map((userSession, sessionIndex) => {
											if(!userSession.user){
												return null
											}

											return (
												<div key={sessionIndex} className="session">
													{ userSession.isStillRunning ? 
														<div className="tooltip-trigger badge">
															<Icon 
																name="play" 
															/>
															<div className="tooltip">
																Still running
															</div>
														</div>
														: null
													}
													<ProfilePicture 
														user={userSession.user} 
														isTiny={true} 
													/>
													<strong>
														{ userSession.user.first_name+' '+userSession.user.last_name }
													</strong>
													<span>
														{ secondsToTimeString(userSession.seconds) }
													</span>
												</div>
											)
										}) }
									</li>
								)
							}) }
							</ul>
						</div>
					}
				</div>
			</div>
		)
	}
}

export default connect(null, { toggleTimer, openModal })(SingleTaskTiming)

SingleTaskTiming.contextType = MainContext